import UserProfilePanel from "./UserProfilePanel";
import withUserData from "./withUserData";
const EnhancedUserProfilePanel = withUserData(UserProfilePanel);
export default EnhancedUserProfilePanel;
